import React, {useEffect, useState} from 'react';

import {connect} from 'react-redux';
// import passwordValidator from 'password-validator';
// import PaymentMethods from '../payments/PaymentMethods';
import PublicCheckoutForm from '../payments/PublicCheckoutForm';
import {Actions as CREATEACCOUNTACTIONS} from '../../../store/actions/createAccountActions';
import {Actions as PAYMENTACTIONS} from '../../../store/actions/paymentActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { stripePromise } from '../../../store/actions/apiURL';

import BuddyFace from '../../../images/buddy-face.png';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

function PayAndRegister({
  createAccount,
  updateUserDetails,
  bundles,
  selectBundle,

  data,
  error,
  profile,
  selectedBundle,
  invoiceNo,
  newOrganisationID,
  creatingAccount,
  userCreated,
  userUpdated,
  acLeadCreated,
  demoAccountCreated,
  specialTerms,
  setNewAccountData,
}) {


  useEffect(() => {
    // load initial data required for anywhere
    if (newOrganisationID){
      // redirect to app dashboard
      // window.switchCompany(newOrganisationID)
      // window.location.href = window.location.hostname.includes('stage') || window.location.hostname.includes('local') ? "https://app.stage.buddy.hr/company-settings/" : "https://buddy.hr/company-settings/"
    }
  },[newOrganisationID]);

  // const [data, setData] = useState({
  //   organisation: "",
  //   vatNo: "",
  //   door: "",
  //   street: "",
  //   city: "",
  //   postcode: "",
  // });


  const handleChange = (event) => {
    setNewAccountData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  const createDemoAccountSubmit = (e) => {
    e.preventDefault();
    console.log('dataToSubmit',data)
    createAccount(data)
  }

  const updateUserSubmit = (e) => {
    e && e.preventDefault();
    // no details to save
    // updateUserDetails(data)
  }

  if (invoiceNo){

    return (

      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden"
        style={{
          background: "white",
          margin: "auto",
            maxWidth: "450px",
          width: "90%",
          padding: "80px 40px 40px",
              top: "50%",
              left: "50%",
              width: "100%",
              transform: "translateY(-50%) TranslateX(-50%)",
              position: "absolute",
        }}
      >
        <div className="px-4 py-8 sm:px-10">

          <div className="mt-6">
            <div>
              <img style={{float:"left", marginRight: 5}} className="h-8 w-auto sm:h-10" src={BuddyFace} alt="Buddy HR Payroll Software Logo" />
              <h2>Your account is ready, hold tight as we take you to your account.</h2>
            </div>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">
            You're being redirected to your account. This should be quick.
          </p>
        </div>
      </div>
    )
  }

  return (

    <div id="PayAndRegister"

      style={{
        background: "white",
        margin: "auto",
          maxWidth: "450px",
        width: "90%",
        padding: "80px 40px 40px",
            top: "50%",
            left: "50%",
            width: "100%",
            transform: "translateY(-50%) TranslateX(-50%)",
            position: "absolute",
      }}
    >

      <div style={{
            background: "#ea611c",
            color: "white",
            fontWeight: "bold",
            padding: "15px 40px",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            textTransform: "uppercase"
          }}>
          <img 
            src={BuddyFace}
            style={{
          width: 30,
          marginRight: 10,
            }}
          />
          PURCHASE {selectedBundle.name}
        </div>

      <div className="px-4 py-8 sm:px-10">

        <div className="mt-6">

          {error && 
            <div className="rounded-md bg-red-50 p-4 mb-6">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm leading-5 font-medium text-red-800">
                    Error: {error}
                  </h3>
                </div>
              </div>
            </div>
          }

          <form onSubmit={createDemoAccountSubmit} className="space-y-6">
            <div>
              <label htmlFor="organisation" className="sr-only">
                Organisation
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['organisation']} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div>
              <label htmlFor="vatNo" className="sr-only">
                Vat No
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['vatNo']} onChange={handleChange} name="vatNo" id="vatNo" placeholder="Vat No" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div>
              <label htmlFor="door" className="sr-only">
                Door No/Name
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['door']} onChange={handleChange} name="door" id="door" placeholder="Door No/Name" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div>
              <label htmlFor="street" className="sr-only">
                Street
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['street']} onChange={handleChange} name="street" id="street" placeholder="Street" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div>
              <label htmlFor="city" className="sr-only">
                City
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['city']} onChange={handleChange} name="city" id="city" placeholder="City" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>

            <div>
              <label htmlFor="postcode" className="sr-only">
                Post Code
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['postcode']} onChange={handleChange} name="postcode" id="postcode" placeholder="Post Code" className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
              </div>
            </div>



            <Elements stripe={stripePromise}>
              <PublicCheckoutForm stripePromise={stripePromise} onSubmit={updateUserSubmit}/>
            </Elements>
          </form>
        </div>
      </div>
      <div style={{marginTop: 20}}>
        <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="https://www.buddy.hr/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="https://www.buddy.hr/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="https://www.buddy.hr/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
        {specialTerms && <p className="text-xs leading-5 text-gray-500 mt-5">{specialTerms}</p>}
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount || {}
  const profile = state && state.my && state.my.profile

  return {
    invoiceNo: state.payment.invoiceNo,
    newOrganisationID: state.payment.newOrganisationID,
    creatingAccount: createAccount.creating || state.payment.stripe.savingCard || state.payment.stripe && state.payment.stripe.processingCharge,
    error: createAccount.error,
    userCreated: true,
    userUpdated: createAccount.userUpdated,
    acLeadCreated: createAccount.acLeadCreated,
    demoAccountCreated: createAccount.demoAccountCreated,
    bundles: state.payment.bundles,
    selectedBundle: state.payment.selectedBundle,
    profile,
    data: createAccount.data
  }
}

const mapDispatchToProps = dispatch => ({
  setNewAccountData: (data) => dispatch(CREATEACCOUNTACTIONS.setNewAccountData(data)),
  // createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
  // updateUserDetails: (data) => dispatch(CREATEACCOUNTACTIONS.updateUserDetails(data)),
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayAndRegister) 
